import router from "../router";
import { ElMessage } from "element-plus";
import { post } from "../utils/request";
import { sha256 } from "js-sha256";
export default {
  name: "HeadBar",
  data() {
    return {
      showable: {
        changePwdForm: false,
      },
      dotNotify: true,
      userInfo: {
        userName: "",
        departmentName: "",
      },
      regionName: JSON.parse(sessionStorage.getItem("regionInfo")).regionName,
      changePwdForm: {
        oldPassword: "",
        newPassword: "",
        newPasswordAgain: "",
      },
    };
  },
  props: {},
  components: {},
  methods: {
    openMsg() {
      this.$notify({
        title: "提示",
        message: "有任务需要接收",
        duration: 0,
        position: "top-left",
        offset: 100,
      });
      this.$notify({
        title: "提示",
        message: "有评价任务",
        duration: 0,
        position: "top-left",
        offset: 200,
      });

      this.dotNotify = false;
    },
    doLogout() {
      ElMessage.success("退出登录成功", {
        duration: 3 * 1000,
      });
      this.$store.commit("REMOVE_INFO");
      router.push("/login");
    },
    handleChangePwd() {
      this.changePwdForm = this.$options.data().changePwdForm;
      this.showable.changePwdForm = true;
    },
    doCancel() {
      this.showable.changePwdForm = false;
    },
    /**
     * @description 修改密码，修改数据库之前验证一下旧密码是否正确
     * @function POST /password/change
     *
     * @param {int} userId 用户名
     * @param {String} oldPassword 旧密码
     * @param {String} newPassword 新密码
     */
    doSubmit() {
      if (this.changePwdForm.oldPassword == "") {
        ElMessage.warning("未输入旧密码", {
          duration: 3 * 1000,
        });
        return;
      }
      if (this.changePwdForm.newPassword.length < 6) {
        ElMessage.warning("新密码不可少于6位", {
          duration: 3 * 1000,
        });
        return;
      }
      if (
        this.changePwdForm.newPassword != this.changePwdForm.newPasswordAgain
      ) {
        ElMessage.warning("两次新密码输入不一致", {
          duration: 3 * 1000,
        });
        return;
      }
      let data = {
        userId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
        oldPassword: sha256(this.changePwdForm.oldPassword),
        newPassword: sha256(this.changePwdForm.newPassword),
      };
      post("/password/change", JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          ElMessage.success("请重新登录", {
            duration: 3 * 1000,
          });
          this.$store.commit("REMOVE_INFO");
          router.push("/login");
        }
      });
      this.showable.changePwdForm = false;
    },
  },
  computed: {
    userName() {
      return JSON.parse(sessionStorage.getItem("userInfo")).name;
    },
    departmentName() {
      return JSON.parse(sessionStorage.getItem("departmentInfo"))
        .departmentName;
    },
  },
};